<template lang="pug">
  hotsite-dcom
    .conteudo
      bloco.-nomargin.-softpadding.-fullheight
        //- HEADER
        header(slot="header")
          titulo.-withbar.-upper Sobre a DCOM
        //- CONTENT
        .texto(slot="content")
          //- cover(:imagem="'static/banner.jpg'")
          .sobre-dcom(v-html="sobre" v-if="sobre")
          loading(slot="content" v-else)
        //- FOOTER
        footer(slot="footer")
          back-and-share
</template>

<style lang="scss">
.sobre-dcom {
  p {
    img {
      max-width: 100%;
      height: 100%;
      border-radius: 7px;
      &.aligncenter {
        display: flex;
        margin: 0 auto;
        margin: 10px auto 10px auto;
      }
      &.alignleft,
      &.alignnone {
        margin: 10px 10px 10px 0;
      }
      &.alignright {
        display: flex;
        margin: 10px 0 10px auto;
      }
    }
  }
}
</style>


<script>
  import BackAndShare from 'COMPONENTS/BackAndShare'
  import Bloco from 'COMPONENTS/Bloco'
  import Cover from 'COMPONENTS/ImagemCover'
  import HotsiteDcom from 'PAGES/dcom/Base'
  import Listagem from 'COMPONENTS/BaseLista'
  import Loading from 'COMPONENTS/Loading'
  import Titulo from 'COMPONENTS/ElementTitle'

  import ConteudoService from '../../../js/api/dcom/ConteudoService'

  export default {
    components: {
      BackAndShare,
      Bloco,
      Cover,
      HotsiteDcom,
      Listagem,
      Loading,
      Titulo
    },
    data () {
      return {
        sobre: ''
      }
    },
    mounted () {
      ConteudoService.getSobreInicial('dcom', 'sobre-a-dcom')
        .then(response => {
          this.sobre = response.data[0].acf.descricao
        })
    }
  }
</script>



// WEBPACK FOOTER //
// Sobre.vue?428828e6